'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dColor$00241 from "./samples.-Sealed$package$-Color$1.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00241 from "./samples.-Sealed$package$-Color$3$$anon$1.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00242 from "./samples.-Sealed$package$-Color$3$$anon$2.js";
import * as $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00243 from "./samples.-Sealed$package$-Color$3$$anon$3.js";
var $p;
/** @constructor */
function $c_Lsamples_Sealed$package$Color$3$(Color$lzy1$8) {
  this.Am = null;
  this.M5 = null;
  this.wo = null;
  this.M4 = null;
  this.Am = new $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00241.$c_Lsamples_Sealed$package$Color$3$$anon$1(Color$lzy1$8, this);
  this.M5 = new $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00242.$c_Lsamples_Sealed$package$Color$3$$anon$2(Color$lzy1$8, this);
  this.wo = new $j_samples$002e$002dSealed$0024package$0024$002dColor$00243$0024$0024anon$00243.$c_Lsamples_Sealed$package$Color$3$$anon$3(Color$lzy1$8, this);
  this.M4 = new ($j_samples$002e$002dSealed$0024package$0024$002dColor$00241.$d_Lsamples_Sealed$package$Color$1.r().C)([this.Am, this.M5, this.wo]);
}
export { $c_Lsamples_Sealed$package$Color$3$ as $c_Lsamples_Sealed$package$Color$3$ };
$p = $c_Lsamples_Sealed$package$Color$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sealed$package$Color$3$;
/** @constructor */
function $h_Lsamples_Sealed$package$Color$3$() {
}
export { $h_Lsamples_Sealed$package$Color$3$ as $h_Lsamples_Sealed$package$Color$3$ };
$h_Lsamples_Sealed$package$Color$3$.prototype = $p;
$p.Yr = (function() {
  return this.M4.x();
});
var $d_Lsamples_Sealed$package$Color$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sealed$package$Color$3$, "samples.Sealed$package$Color$3$", ({
  qI: 1,
  e: 1,
  aa: 1
}));
export { $d_Lsamples_Sealed$package$Color$3$ as $d_Lsamples_Sealed$package$Color$3$ };
